import { Module, Mutation, VuexModule } from 'vuex-module-decorators';


@Module({
	stateFactory: true,
	namespaced: false,
	name: 'onboarding'
})
export default class Onboarding extends VuexModule {

	private _onboarding = true;
	private _textOnboarding = true;
	private _backgroundOnboarding = true;

	get onboarding(): boolean{
		return this._onboarding;
	}

	get textOnboarding(): boolean{
		return this._textOnboarding;
	}

	get backgroundOnboarding(): boolean{
		return this._backgroundOnboarding;
	}

	@Mutation
	setOnboarding(payload: any) {
		this._onboarding=payload;
	}

	@Mutation
	setTextOnboarding(payload: any) {
		this._textOnboarding=payload;
	}

	@Mutation
	setBackgroundOnboarding(payload: any) {
		this._backgroundOnboarding=payload;
	}
}
